import { Label, TextField } from "@towersystems/roam-common-native";
import { Controller, useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { OrderItemFormValues } from "../../types";
import { useTranslation } from "../../../../../../utilities/i18n";

export interface BarcodeFormInputProps {}

export const BarcodeFormInput = ({}: BarcodeFormInputProps) => {
  const { control, watch } = useFormContext<OrderItemFormValues>();
  const { t } = useTranslation("stockorder");

  const watchedProductId = watch("productId");
  const watchedId = watch("id");
  const disabled = watchedProductId || watchedId;

  return (
    <View pointerEvents={disabled ? "none" : "auto"}>
      <Label label={t("form.barcode.label")}></Label>
      <Controller
        name="barcode"
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            value={value}
            onChangeText={onChange}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.barcode.placeholder")}
            editable={!disabled}
            selectTextOnFocus={!disabled}
            style={{
              opacity: disabled ? 0.7 : 1,
            }}
          />
        )}
      />
    </View>
  );
};
